/* eslint-disable no-magic-numbers */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */
import { Field } from 'Util/Query';

/** @namespace Bookland/Query/Product/Query */
export class ProductQuery {
    getOtherProductsInCategory(categoryId, size = 6) {
        return new Field('otherProductsInCategory')
            .addArgument('category_id', 'Int!', categoryId)
            .addArgument('size', 'Int!', size)
            .addFieldList(['sku', 'stock_status']);
    }
}

export default new ProductQuery();
